module.exports = __webpack_public_path__ + "static/media/infoUserInviteWhite.9f571c66.svg";